import React, { useEffect } from "react";
import About_banner from './about-banner/About_banner'
import About_content from './about-content/About_content'
import Counter from './about-counter/Counter'
import Core_team from './core-team/Core_team'
import Our_objective from './our-objective/Our_objective'
import Download_app from '../home/download-app/Download_app'

const About_us = () => {

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
        <About_banner />
        <About_content />
        {/* <Counter /> */}
        {/* <Core_team /> */}
        <Our_objective />
        <Download_app />
    </>
  )
}

export default About_us